<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
<!--      <a-form-model-item prop="id" v-if="formType === 1">-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('id')}}<template slot="title">{{$t('id')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.id"  :placeholder="$t('通用.输入.请输入')+$t('id')" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item prop="updateBy" >-->
<!--        <span slot="label" >-->
<!--          <a-tooltip>-->
<!--            {{$t('修改人')}}<template slot="title">{{$t('修改人')}}</template>-->
<!--          </a-tooltip>-->
<!--        </span>-->
<!--        <a-input v-model="form.updateBy" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('修改人')" />-->
<!--      </a-form-model-item>-->
      <a-form-model-item prop="giftNum" >
        <span slot="label" >
          <a-tooltip>
            {{$t('投放(天数)')}}<template slot="title">{{$t('投放(天数)')}}</template>
          </a-tooltip>
        </span>
        <a-input-number :min = '1' :max = '360' style="width: 45%" v-model="form.giftNum"  :placeholder="$t('通用.输入.请输入')+$t('投放(天数)')" />
      </a-form-model-item>
      <a-form-model-item prop="money" >
        <span slot="label" >
          <a-tooltip>
            {{$t('充值金额')}}<template slot="title">{{$t('充值金额')}}</template>
          </a-tooltip>
        </span>
        <a-input-number  :min = '1' :max = '5000' style="width: 45%" v-model="form.money"  :maxLength="150" :placeholder="$t('通用.输入.请输入')+$t('充值金额')" />
      </a-form-model-item>


      <a-form-model-item prop="sort" >
        <span slot="label" >
          <a-tooltip>
            {{$t('序号')}}<template slot="title">{{$t('序号')}}</template>
          </a-tooltip>
        </span>
        <a-input-number :min = '1' :max = '50' style="width: 45%" v-model="form.sort"  :placeholder="$t('通用.输入.请输入')+$t('序号')" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('描述备注')}}<template slot="title">{{$t('描述备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :maxLength="100" :placeholder="$t('通用.输入.请输入')+$t('描述备注')" />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getRechargeAble, addRechargeAble, updateRechargeAble } from '@/api/zb/rechargeAble'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        updateBy: null,

        createTime: null,

        money: null,

        remark: null,

        giftNum: null,
        sort: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        updateBy: null,
        createTime: null,
        money: null,
        remark: null,
        giftNum: null,
        sort: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getRechargeAble({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateRechargeAble(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addRechargeAble(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
